import { jsx as _jsx } from "react/jsx-runtime";
const SvgComponent = ({ fill = '#6D6473', ...props }) => (_jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: 8, height: 14, fill: "none", ...props, children: _jsx("path", { strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round", stroke: fill, d: "M1 13L7 7L1 1" }) }));
export default SvgComponent;
